import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    pageTitle: {
        id: 'classNotes.pageTitle',
        description: 'Notes page title',
        defaultMessage: 'Notes details - AWS Training and Certification',
    },
    trainingBriefingHeader: {
        id: 'classNotes.trainingBriefingHeader',
        defaultMessage: 'Customer training briefing',
    },
    whatTheCustomerDoes: {
        id: 'classNotes.whatTheCustomerDoes',
        defaultMessage: 'What does the customer do?',
    },
    whereAreTheyInTheirCloudJourney: {
        id: 'classNotes.whereAreTheyInTheirCloudJourney',
        defaultMessage: 'Where are they in cloud journey?',
    },
    motivationsForUsingAws: {
        id: 'classNotes.motivationsForUsingAws',
        defaultMessage: 'Motivations for using AWS',
    },
    specialNeedsForTrainingDelivery: {
        id: 'classNotes.specialNeedsForTrainingDelivery',
        defaultMessage: 'Special training needs',
    },
    instructorNotesHeader: {
        id: 'classNotes.instructorNotesHeader',
        defaultMessage: 'Instructor notes',
    },
    notesEditedHeader: {
        id: 'classNotes.notesEditedHeader',
        defaultMessage: 'Edited',
    },
    editedByText: {
        id: 'classNotes.editedByText',
        defaultMessage: '{formattedDateTime} by {author}',
    },
});

export default messages;
